export const TARGET_DATE = new Date('2025-06-15T00:00');

export const BOOK_A_DEMO_LINK =
  'https://meetings.hubspot.com/mharalson?uuid=df779104-51a2-43be-80fa-f8fc542c2ed7';
export const BOOK_A_DEMO_LINK_NEW =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ3qYjyNFYq71l2j14k0D2uHepSTbJ1rqhnfy9KJJxEgI0rDBYlAM3lq1sRoKuozm0gIMxtqugJT?gv=true';

export const BOOK_A_SENSORS_DEMO_LINK =
  'https://meetings.hubspot.com/mharalson/meet-about-sensors-with-michael-haralson';

export const BOOK_A_RESEARCH_CALL_LINK =
  'https://meetings.hubspot.com/mharalson?uuid=597f70b5-efa6-4cd4-89ef-af25c6dad16f';
